import script from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingAnimation.vue?vue&type=script&setup=true&lang=js"

import "./LoadingAnimation.vue?vue&type=style&index=0&id=63cf851a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63cf851a"]])

export default __exports__